<template>
  <terms id="terms" />
</template>

<script>
import Terms from '@/components/Terms'
export default {
  components: {
    Terms,
  }
}
</script>

<style>
  #terms {
    margin-top: 3em;
    margin-bottom: 3em;
  }

</style>
